import { createSelector } from 'reselect';

const templateSelector = (state) => state.template;

export const selectTemplate = createSelector(
  [templateSelector],
  (template) => template.templates
);

export const selectActiveUserTemplates = createSelector(
  [templateSelector],
  (template) =>
    template.templates.email.user.content.filter(
      (temp) => temp.active !== false
    )
);

export const selectActiveDocumentTemplates = createSelector(
  [templateSelector],
  (template) =>
    template.templates.document.user.content.filter(
      (temp) => temp.active !== false
    )
);

export const emailUserTemplateLoading = createSelector(
  [templateSelector],
  (template) => template.templates.email.user.loading
);

export const emailSystemTemplateLoading = createSelector(
  [templateSelector],
  (template) => template.templates.email.system.loading
);

export const documentUserTemplateLoading = createSelector(
  [templateSelector],
  (template) => template.templates.document.user.loading
);

export const documentSystemTemplateLoading = createSelector(
  [templateSelector],
  (template) => template.templates.document.system.loading
);

export const smsUserTemplateLoading = createSelector(
  [templateSelector],
  (template) => template.templates.sms.user.loading
);

export const smsSystemTemplateLoading = createSelector(
  [templateSelector],
  (template) => template.templates.sms.system.loading
);

export const singleTemplateLoading = createSelector(
  [templateSelector],
  (template) => template.fetchingSingleTemplateLoading
);

export const updatingTemplate = createSelector(
  [templateSelector],
  (template) => template.updatingTemplate
);